function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .iconoVer-1 {\r\n        fill: #243165;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "iconoVer-1",
  d: "M19,14.4c-.6-1.1-1.4-2-2.4-2.7-1.2-.9-2.6-1.4-4-1.5-.7,0-1.3,0-2,.1-1.2.2-2.3.7-3.3,1.5-.9.7-1.6,1.6-2.2,2.6-.1.2-.1.4,0,.6,0,.2.2.3.3.4.4.2.8,0,1-.3.5-.8,1-1.4,1.6-2,.6-.5,1.3-.9,2-1.2-.8.6-1.4,1.6-1.4,2.7,0,.9.4,1.8,1,2.5.1.1.2.2.4.3-.1,0-.3-.1-.4-.2-.8-.4-1.5-.9-2.1-1.5-.1-.1-.3-.2-.5-.2-.2,0-.4,0-.5.2-.3.3-.3.7,0,1,.5.6,1.1,1,1.7,1.4,1.1.6,2.2,1,3.4,1.1.2,0,.4,0,.5,0,.6,0,1.3,0,1.9-.2,1.2-.3,2.2-.9,3.2-1.7.7-.6,1.4-1.4,1.9-2.3.1-.2.1-.5,0-.7ZM12.1,13.1c.4,0,.8.2,1.1.5.3.3.5.7.5,1.2,0,.9-.7,1.6-1.6,1.6h0c-.4,0-.8-.2-1.1-.5-.3-.3-.5-.7-.5-1.2,0-.9.7-1.6,1.6-1.6h0ZM16,16.5c-.6.5-1.2.8-1.8,1,.1,0,.3-.2.4-.3.7-.7,1-1.5,1-2.5,0-.9-.4-1.8-1-2.5-.1-.1-.2-.2-.4-.3,1.4.5,2.5,1.4,3.3,2.8-.4.7-1,1.3-1.5,1.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconoVer-1",
  d: "M1.3,17.5V1.2h11.8v3h2.6v5.1c.4.2.8.4,1.3.6V2.7l-2.9-2.7H0v18.7h6c-.5-.4-1-.8-1.4-1.2H1.3ZM14,1.2l2,2h-2V1.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "iconoVer-1",
  d: "M15.7,11.7h.5c-.2,0-.3-.2-.5-.3v.3Z"
}))));

var SvgVer = function SvgVer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.1 19.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VER.1124e4b2.svg";
export { ForwardRef as ReactComponent };